import React, { useState, useEffect } from "react";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import { Box, Divider, TextField } from "@mui/material";
import InputLabel from "@mui/material/InputLabel";

export default function Schedule(props) {
  const { setState } = props;

  const [schedulevalue, setSchedulevalue] = React.useState({
    repeat_frequency: "none",
    actualhours: "",
    start_date_time: "",
    end_date_time: "",
  });

  const [endDateTimeError, setEndDateTimeError] = useState("");
  const [hoursError, setHoursError] = useState("");
  const [totalCalculatedHours, setTotalCalculatedHours] = useState(0);

  const toDatetimeLocal = (date) => {
    const pad = (n) => n.toString().padStart(2, "0");
    return (
      date.getFullYear() +
      "-" +
      pad(date.getMonth() + 1) +
      "-" +
      pad(date.getDate()) +
      "T" +
      pad(date.getHours()) +
      ":" +
      pad(date.getMinutes())
    );
  };

  const minDate1 = toDatetimeLocal(new Date());

  const twoMonthsFromStartDate = (startDate) => {
    if (!startDate) {
      return "";
    }
    const date = new Date(startDate);
    date.setMonth(date.getMonth() + 2);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    return `${year}-${month}-${day}T${hours}:${minutes}`;
  };

  // const validateHours = (hours) => {
  //   if (hours && parseFloat(hours) > totalCalculatedHours) {
  //     setHoursError("Hours cannot exceed the total duration.");
  //     setSchedulevalue((prevState) => ({
  //           ...prevState,
  //           [actualhours]: "",
  //     }));
  //     setState((prevState) => ({
  //           ...prevState,
  //           [actualhours]: "",
  //         }));
  //   } else {
  //     setHoursError("");
  //   }
  // };

  // const handleChange = (e) => {
  //   const { id, value } = e.target;
  //   const newState = {
  //     ...schedulevalue,
  //     [id]: value,
  //   };
  //   setSchedulevalue((prevState) => ({
  //     ...prevState,
  //     [id]: value,
  //   }));
  //   setState((prevState) => ({
  //     ...prevState,
  //     [id]: value,
  //   }));
  //   if (id === "actualhours") {
  //     validateHours(value);
  //     // if (!hoursError) {
      
  //     //   setState((prevState) => ({
  //     //     ...prevState,
  //     //     [id]: "",
  //     //   }));
  //     //   setSchedulevalue((prevState) => ({
  //     //     ...prevState,
  //     //     [id]: "",
  //     //   }));
  //     // }
      
  //   }

  //   // setSchedulevalue(newState);
  //   // setState(newState);

  //   console.log("new state", newState);

  //   if (id === "start_date_time" || id === "end_date_time") {
  //     if (newState.start_date_time && newState.end_date_time) {
  //       const start = new Date(newState.start_date_time);
  //       const end = new Date(newState.end_date_time);

  //       if (end < start) {
  //         setEndDateTimeError("End date & time cannot be earlier than Start date & time.");
  //         setTotalCalculatedHours(0);
  //       } else {
  //         setEndDateTimeError("");
  //         const timeDiff = Math.abs(end.getTime() - start.getTime());
  //         const hours = timeDiff / (1000 * 60 * 60);
  //         setTotalCalculatedHours(hours);
  //         validateHours(newState.actualhours);
  //       }
  //     } else {
  //       setEndDateTimeError("");
  //       setTotalCalculatedHours(0);
  //     }
  //   }
  // };

  const validateHours = (hours, totalCalculatedHours) => {
    if (hours && parseFloat(hours) > totalCalculatedHours) {
      return "Hours cannot exceed the total duration.";
    }
    return "";
  };
  
  const handleChange = (e) => {
    const { id, value } = e.target;
  
    // Update local state and get the new state value for validation
    setState(prevState => {
      const newState = {
        ...prevState,
        [id]: value
      };
  
      // Update parent state
      setSchedulevalue(newState);
  
      // Validation logic for hours field
      if (id === "actualhours") {
        const error = validateHours(value, totalCalculatedHours);
        setHoursError(error);
      }
  
      // Validation logic for date/time fields
      if (id === "start_date_time" || id === "end_date_time") {
        if (newState.start_date_time && newState.end_date_time) {
          const start = new Date(newState.start_date_time);
          const end = new Date(newState.end_date_time);
  
          if (end < start) {
            setEndDateTimeError("End date & time cannot be earlier than Start date & time.");
            setTotalCalculatedHours(0);
          } else {
            setEndDateTimeError("");
            const timeDiff = Math.abs(end.getTime() - start.getTime());
            const hours = timeDiff / (1000 * 60 * 60);
            setTotalCalculatedHours(hours);
            const hoursError = validateHours(newState.actualhours, hours);
            setHoursError(hoursError);
          }
        } else {
          setEndDateTimeError("");
          setTotalCalculatedHours(0);
          setHoursError("");
        }
      }
  
      return newState; // Return the new state to update schedulevalue
    });
  };

  return (
    <React.Fragment>
      <Box sx={{ pt: 1 }}>
        <Divider />
        <br />
        <Box borderColor="error.main">
          <Grid container spacing={3}>
            <Grid item md={3} xs={12}>
              <InputLabel>
                Start Date {"&"} Time
                <small style={{ paddingLeft: "10px" }}>required</small>
                <small style={{ color: "red" }}>*</small>
              </InputLabel>
              <TextField
                fullWidth
                name="start_date_time"
                id="start_date_time"
                type="datetime-local"
                value={schedulevalue.start_date_time || ""}
                onChange={handleChange}
                required
                variant="outlined"
                inputProps={{
                  min: minDate1,
                }}
                InputProps={{
                  style: {
                    height: "40px",
                  },
                }}
              />
            </Grid>
            <Grid item md={3} xs={12}>
              <InputLabel>
                End Date {"&"} Time
                <small style={{ paddingLeft: "10px" }}>required</small>
                <small style={{ color: "red" }}>*</small>
              </InputLabel>
              <TextField
                fullWidth
                name="end_date_time"
                id="end_date_time"
                type="datetime-local"
                value={schedulevalue.end_date_time || ""}
                onChange={handleChange}
                required
                variant="outlined"
                inputProps={{
                  min: schedulevalue.start_date_time ? schedulevalue.start_date_time : minDate1,
                  max: twoMonthsFromStartDate(schedulevalue.start_date_time),
                }}
                InputProps={{
                  style: {
                    height: "40px",
                  },
                }}
                error={Boolean(endDateTimeError)}
                helperText={endDateTimeError}
              />
            </Grid>
            <Grid item xs={3}>
              <InputLabel>
                Hours<small style={{ paddingLeft: "10px" }}>required</small>
                <small style={{ color: "red" }}>*</small>
              </InputLabel>
              <TextField
                fullWidth
                name="actualhours"
                id="actualhours"
                value={schedulevalue.actualhours || ""}
                disabled={!schedulevalue.start_date_time || !schedulevalue.end_date_time || Boolean(endDateTimeError)}
                onChange={handleChange}
                onKeyPress={(e) => {
                  const charCode = e.which ? e.which : e.keyCode;
                  if (charCode > 31 && (charCode < 48 || charCode > 57)) {
                    e.preventDefault();
                  }
                }}
                required
                type="number"
                autoComplete="off"
                InputProps={{
                  style: {
                    height: "40px",
                  },
                }}
                error={Boolean(hoursError)}
                helperText={hoursError || (schedulevalue.start_date_time && schedulevalue.end_date_time && `Maximum Hours: ${totalCalculatedHours.toFixed(2)}`)}
              />
            </Grid>
            <Grid item xs={12}>
              <Typography variant="h8">
                <strong>Note:</strong>
                <small>
                  {" "}
                  Please select the Start time and Stop time which includes the idle hours.
                </small>
              </Typography>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </React.Fragment>
  );
}